"use client"

import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { IFaqFields } from '@/types/contentful'
import { useRouter } from 'next/navigation'
import FaqDetail from '../detail/_components/FaqDetail'
import { ArrowRight } from '@peacecover/icon'
import { GA_EVENTS } from '@/utils/analytics'

interface IFaqItemProps {
  faq: IFaqFields
  selectedCategory?: string
  isModal?: boolean
  isLight?: boolean
}

const FaqItem: React.FC<IFaqItemProps> = ({ faq, selectedCategory, isModal, isLight = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const router = useRouter()
  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleFaqClick = () => {
    GA_EVENTS.FAQ_VIEW(faq.title)
  }

  const handleNavigateToDetail = () => {
    const categoryQuery = selectedCategory ? `&category=${encodeURIComponent(selectedCategory)}` : ''
    router.push(`/faq/detail?id=${faq.id}${categoryQuery}`)
  }

  return (
    <div className='border-b border-surface-lv2 last:border-b-0'>
      {/* 모바일 환경에서는 링크로 이동 */}
      <div className={`${isModal ? 'hidden' : 'sm:hidden'}`}>
        <button className='flex items-center justify-between w-full gap-2 py-4' onClick={() => {
          handleFaqClick()
          handleNavigateToDetail()
        }}>
          <p className={`font-pretendard-regular text-[15px] text-left ${isLight ? 'text-main-light-2' : 'text-text-main-lv2'}`}>
            {faq.title || faq.question}
          </p>
          <ArrowRight size={16} className='text-text-main-lv4' />
        </button>
      </div>

      {/* 데스크탑 환경에서는 모달로 표시 */}
      <div className={`${isModal ? 'block' : 'hidden'} sm:block`}>
        <button
          onClick={() => {
            setIsModalOpen(true)
            handleFaqClick()
          }}
          className="flex items-center gap-[16px] py-[16px] w-full justify-between"
        >
          <p className={`font-pretendard-semibold text-[15px] ${isLight ? 'text-main-light-3' : 'text-text-main-lv3'} ${isModal ? '!text-[14px] !font-pretendard-medium' : ''}`}>
            {faq.title || faq.question}
          </p>
          <ArrowRight size={16} className='text-text-main-lv4' />
        </button>

        <AnimatePresence mode="wait">
          {isModalOpen && faq && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className={`fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center ${isModal ? 'px-[24px]' : ''}`}
              onClick={handleCloseModal}
            >
              <div
                className={`${isLight ? 'bg-white' : 'bg-white dark:bg-black'} py-7 px-2 rounded-lg max-w-sm w-full relative`}
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={handleCloseModal}
                  className="absolute top-2 right-4 text-3xl p-2"
                >
                  &times;
                </button>
                <FaqDetail isModal={true} id={faq.id} isLight={isLight} />
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  )
}

export default FaqItem
